import React, {Component} from 'react';
import KeywordsPackListDivRow from './KeywordsPackListDivRow';

const KeywordsPackListDivs = ({keywordsPacks, onDelete}) => {
    return (
        <div>
            {
                keywordsPacks.map(keywordsPack => <KeywordsPackListDivRow
                    key={keywordsPack.id}
                    keywordsPack={keywordsPack}
                    onDelete={onDelete}
                />)
            }
        </div>
    );
};

export default KeywordsPackListDivs;


// WEBPACK FOOTER //
// ./web/src/components/keywords-pack/KeywordsPackListDivs.jsx